/**
 * Portals Notion editor dialogs (math / image / YouTube / date) from the
 * exiq-notion-editor shadow DOM to document.body so they cover the full viewport.
 */
(function initNotionEditorModalsPatch() {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  if (window.__exiqNotionEditorModalsPatchInitialized) {
    return;
  }
  window.__exiqNotionEditorModalsPatchInitialized = true;

  const PATCH_FLAG = "__exiqNotionEditorModalsPatchApplied";
  const OVERLAY_SELECTOR = ".math-modal-overlay";

  function portalOverlayToBody(overlay) {
    if (!(overlay instanceof HTMLElement)) {
      return;
    }

    if (overlay.dataset.exiqPortaled === "true") {
      return;
    }

    overlay.dataset.exiqPortaled = "true";
    overlay.style.position = "fixed";
    overlay.style.inset = "0";
    overlay.style.zIndex = "10000";

    if (overlay.parentNode !== document.body) {
      document.body.appendChild(overlay);
    }
  }

  function scanForOverlays(root) {
    if (!root || typeof root.querySelectorAll !== "function") {
      return;
    }

    root.querySelectorAll(OVERLAY_SELECTOR).forEach(portalOverlayToBody);
  }

  function observeOverlayContainer(root) {
    if (!root || root[PATCH_FLAG]) {
      return;
    }

    root[PATCH_FLAG] = true;
    scanForOverlays(root);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) {
            return;
          }

          if (node.matches(OVERLAY_SELECTOR)) {
            portalOverlayToBody(node);
            return;
          }

          scanForOverlays(node);
        });
      });
    }).observe(root, {
      childList: true,
      subtree: true,
    });
  }

  function attachToShadowRoot(shadowRoot) {
    if (!shadowRoot || shadowRoot.__exiqModalsPatchShadowBound) {
      return;
    }

    shadowRoot.__exiqModalsPatchShadowBound = true;
    observeOverlayContainer(shadowRoot);
  }

  function scanCustomElements(root) {
    if (!root || typeof root.querySelectorAll !== "function") {
      return;
    }

    root.querySelectorAll("exiq-notion-editor").forEach((element) => {
      if (element.shadowRoot) {
        attachToShadowRoot(element.shadowRoot);
      }
    });
  }

  function observeEditors() {
    observeOverlayContainer(document);
    scanCustomElements(document);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) {
            return;
          }

          if (node.tagName === "EXIQ-NOTION-EDITOR" && node.shadowRoot) {
            attachToShadowRoot(node.shadowRoot);
          }

          if (node.matches(OVERLAY_SELECTOR)) {
            portalOverlayToBody(node);
          }

          scanForOverlays(node);
          scanCustomElements(node);

          if (node.shadowRoot) {
            attachToShadowRoot(node.shadowRoot);
          }
        });
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeEditors);
  } else {
    observeEditors();
  }
})();
